// extracted by mini-css-extract-plugin
module.exports = {"footer-info":"_2Qkd8aR36GZO0tV3Qmv9nt","body":"_3y5VXHj0oWLwMQxcveI53W","dialog":"_3h_aM-nO5BRuaCggqJHIXK","table":"_1r3EQpeF1KRTLRascu83Ja","text-elipsis":"spr5r8oGjouitsRhRys6_"};